import { FC, useContext, useMemo } from 'react'
import { useQuery } from 'react-query'
import {
  createResponseContext,
  initialQueryResponse,
  QUERIES,
  stringifyRequestQuery,
  WithChildren,
} from '../../../../../../_metronic/helpers'
import { useQueryRequest } from './QueryRequestProvider'
import { AtendimentoView } from '../../../atendimento/core/_models'
import { getAtendimentosByResponsavel } from './_requests'
import { useModal } from '../../../../../components'

const QueryResponseContext = createResponseContext<AtendimentoView>(initialQueryResponse)

export const QueryResponseProvider: FC<WithChildren> = ({ children }) => {
  const { isOpen } = useModal()
  const { state } = useQueryRequest()

  const query = useMemo(() => stringifyRequestQuery(state), [state])

  const {
    isFetching,
    isError,
    refetch,
    data: response,
  } = useQuery(
    [QUERIES.MEUS_ATENDIMENTOS_LIST, query, isOpen],
    () => getAtendimentosByResponsavel(query),
    {
      cacheTime: 0,
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      enabled: !isOpen,
    }
  )

  return (
    <QueryResponseContext.Provider
      value={{ isLoading: isFetching, isError, refetch, response, query }}
    >
      {children}
    </QueryResponseContext.Provider>
  )
}

export const useQueryResponse = () => useContext(QueryResponseContext)
